<form [formGroup]="form" class="container">
  <div class="row">
    <mat-form-field class="col-8">
      <input matInput formControlName="title" placeholder="Title" maxlength="100" />
    </mat-form-field>
    <mat-form-field class="col-4">
      <input matInput type="number" formControlName="revision" placeholder="Revision #" step="0.1" min="0" />
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-12">
      <textarea matInput formControlName="description" placeholder="Description" maxlength="250"></textarea>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-5">
      <mat-label>Change Date</mat-label>
      <input id="datepicker" matInput [matDatepicker]="datepicker" formControlName="changeDate" />
      <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
      <mat-datepicker [startAt]="this.form.get('changeDate').value" #datepicker></mat-datepicker>
    </mat-form-field>
  </div>
</form>

<mat-dialog-actions class="justify-content-end mt-auto">
  <button mat-raised-button color="primary" (click)="saveChangeLog()" [disabled]="form.invalid">Save</button>
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>